import React from "react"
import { connect } from "react-redux"
import { CircularProgress } from "@material-ui/core"
import {
  campaignPopupLoading,
  fetchCampaignPerformanceByBrowserAsync,
  resetCampaignPopupTable,
} from "../campaignPopupActions"
import CampaignPopupPerformanceByBrowserChart from "./charts/performanceByBrowserChart"
import CampaignPopupPerformanceByBrowserList from "./lists/performanceByBrowserList"
import RequestsService from "../../api/requestsService"

class CampaignPopupPerformanceByBrowser extends React.Component {
  componentDidMount() {
    this.getPerformanceByBrowser()
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (
      JSON.stringify(prevProps.datePickerDates.startDate) !== JSON.stringify(this.props.datePickerDates.startDate) ||
      JSON.stringify(prevProps.datePickerDates.endDate) !== JSON.stringify(this.props.datePickerDates.endDate)
    ) {
      this.getPerformanceByBrowser()
    }
  }

  componentWillUnmount() {
    this.props.dispatch(resetCampaignPopupTable("performanceByBrowser"))
    RequestsService.cancelRequest("performance-by-browser-request")
  }

  getPerformanceByBrowser = () => {
    RequestsService.cancelRequest("performance-by-browser-request")
    this.props.dispatch(campaignPopupLoading())
    this.props.dispatch(
      fetchCampaignPerformanceByBrowserAsync(
        this.props.campaign,
        this.props.datePickerDates.startDate,
        this.props.datePickerDates.endDate
      )
    )
  }

  render() {
    let loadingIndicator = null
    let browsersChartData = []
    let performanceByBrowser = null

    if (this.props.isLoading) {
      loadingIndicator = (
        <div className="campaign-popup-loading d-flex align-items-center justify-content-center">
          <CircularProgress className="loader" size={40} />
        </div>
      )
    } else {
      browsersChartData = this.props.performanceByBrowser.slice(
        (this.props.currentPage - 1) * this.props.itemsPerPage,
        this.props.currentPage * this.props.itemsPerPage
      )

      performanceByBrowser = (
        <div>
          <CampaignPopupPerformanceByBrowserChart data={browsersChartData} campaign={this.props.campaign} />
          <CampaignPopupPerformanceByBrowserList />
        </div>
      )
    }

    return (
      <>
        {loadingIndicator}
        {performanceByBrowser}
      </>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    campaign: state.campaignPopupV2.campaign,
    datePickerDates: {
      startDate: state.campaignPopupV2.datePickerDates.startDate,
      endDate: state.campaignPopupV2.datePickerDates.endDate,
    },
    isLoading: state.campaignPopupV2.isLoading,
    performanceByBrowser: state.campaignPopupV2.performanceByBrowser.dataForTable,
    itemsPerPage: state.campaignPopupV2.performanceByBrowser.itemsPerPage,
    currentPage: state.campaignPopupV2.performanceByBrowser.currentPage,
  }
}

export default connect(mapStateToProps)(CampaignPopupPerformanceByBrowser)
